import { render, staticRenderFns } from "./channelSelector.vue?vue&type=template&id=f1298b1c"
import script from "./channelSelector.vue?vue&type=script&lang=js"
export * from "./channelSelector.vue?vue&type=script&lang=js"
import style0 from "./channelSelector.vue?vue&type=style&index=0&id=f1298b1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports